__webpack_require__.p = "/ws_monitoring/";